import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';

export default function RHFAutocomplete({
  name,
  label,
  helperText,
  options = [],
  getOptionLabel = (option) => option?.name ?? '',
  loading = false, // ✅ tambahkan loading flag
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const selectedOption =
          options.find((opt) => opt.id === value || opt.id === value?.id) || null;

        return (
          <Autocomplete
            options={options}
            value={selectedOption}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            loading={loading} // ✅ Autocomplete detect loading
            loadingText="Loading data..." // ✅ Ganti "No options" jadi Loading
            onChange={(event, newValue) => onChange(newValue ? newValue.id : '')}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                error={!!error}
                helperText={error?.message || helperText}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? <CircularProgress size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        );
      }}
    />
  );
}

RHFAutocomplete.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.node,
  options: PropTypes.array,
  getOptionLabel: PropTypes.func,
  loading: PropTypes.bool,
};